/*
 | Monitoreo interno de la Inteligencia Artificial vendida (solo superadministrador).
 |
 | Va en su propio archivo y no en satelite.js porque no es el catalogo de planes: aquellos endpoints
 | dan de alta y editan lo que se vende, y estos solo LEEN lo que ya se vendio y lo que costo el
 | proveedor. Son cuatro GET, todos bajo /v1/satelites/ia/monitoreo/.
 */
const sateliteIaMonitoreo = {
  // Totales, serie por dia y repartos por tipo y por modelo de un rango de fechas
  readMonitoreoIaResumen: 'satelites/ia/monitoreo/resumen',

  // Una fila por licencia de IA vendida; paginado y ordenable por costo, consumo o fecha
  readMonitoreoIaVentas: 'satelites/ia/monitoreo/ventas',

  // La ficha de una licencia: consumo por app, ciclos cerrados y totales por tipo de generacion
  readMonitoreoIaVenta: 'satelites/ia/monitoreo/ventas/{{uuid_licencia}}',

  // El detalle fino: una fila por generacion de IA de esa licencia, paginado
  readMonitoreoIaGeneraciones: 'satelites/ia/monitoreo/ventas/{{uuid_licencia}}/generaciones',

  /*
   | La conciliacion con el proveedor. De las dos mitades del costo medimos una sola: los tokens
   | vienen en cada respuesta y son exactos, los dolares no los informa nadie. El GET cruza los
   | tokens de cada mes con la factura; los dos PUT cargan lo unico que no se puede medir —el
   | importe que facturo el proveedor— y mantienen el precio de cada modelo sin un despliegue.
   */
  readMonitoreoIaConciliacion: 'satelites/ia/monitoreo/conciliacion',
  updateMonitoreoIaFactura: 'satelites/ia/monitoreo/conciliacion/factura',
  updateMonitoreoIaPrecio: 'satelites/ia/monitoreo/conciliacion/precio',

  // Los ajustes que antes vivian en el .env del servidor: interruptores, proveedor,
  // modelos y claves. Lo que se guarda pisa la configuracion desde la proxima peticion.
  readMonitoreoIaAjustes: 'satelites/ia/monitoreo/ajustes',
  updateMonitoreoIaAjuste: 'satelites/ia/monitoreo/ajustes'
}

export default sateliteIaMonitoreo
